'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRecordsAsList;

var _ = require('_');

function getRecordsAsList(acceptedRecord) {
  if (!(0, _.isArray)(acceptedRecord)) {
    return [acceptedRecord];
  }
  return acceptedRecord;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/utils/getRecordsAsList.js
// module id = 439
// module chunks = 0